import { Component, OnInit } from '@angular/core';
import { nav_path } from '../../../../app-routing.module';
import { dummyStory, Story } from '../../../../shared/interfaces/story';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConsoleLoggerService } from '../../../../core/services/console-logger.service';
import { ChangeEvent, CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { PublishDialogComponent } from '../../new-story/publish-dialog/publish-dialog.component';
import { FirestoreService } from '../../../../shared/services/firestore.service';
import { StoryService } from '../../../../shared/services/story.service';
import { SeoService } from '../../../../core/services/seo.service';

@Component({
  selector: 'anon-edit-story',
  templateUrl: './edit-story.component.html',
  styleUrls: ['./edit-story.component.scss']
})
export class EditStoryComponent implements OnInit {
  public readonly nav_path = nav_path;
  public storyLoaded = false;
  story_id: string | null;
  public story: Story = dummyStory;
  private storyBackup: Story = dummyStory;
  private title = "Edit story page";

  storyCharacterCount: number = 0;
  storyWordCount: number = 0;
  editorConfig = {
    wordCount: {
      onUpdate: (stats:any) => {
        this.storyCharacterCount = stats.characters;
        this.storyWordCount = stats.words;
      }
    },
  };

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private db: FirestoreService,
    private cLog: ConsoleLoggerService,
    private storyService: StoryService,
    private seo: SeoService
  ) { this.story_id = this.route.snapshot.paramMap.get('storyID'); }

  async ngOnInit() {
    if (this.story_id) {
      const docSnap = await this.db.docSnap(`stories/${this.story_id}`);
      if (!docSnap.exists()) { this.cLog.error(`story does not exist: '${this.story_id}'`, this.story_id) }
      this.story = docSnap.data() as Story;

      this.seo.generateTags({
        title: `Edit ${this.story.title}`,
        description: `Anonymous Systems ${this.title}`,
        route: `${nav_path.privateStories}/${this.story.slug}/edit`
      });

      this.storyBackup = {...docSnap.data() as Story};
      this.storyLoaded = true;
    }
  }

  previewStory() {
    this.dialog.open(PublishDialogComponent, {
      panelClass: 'publish-dialog-container',
      id: 'publish-dialog',
      data: { story: {...this.story, id: this.story_id} },
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw'
    })
  }

  onChange({editor}: ChangeEvent) {
    if (this.story && editor) {
      this.storyService.parseEditorContent(editor, this.story);
      this.storyService.calculateStoryReadTime(this.story, this.storyWordCount);
    }
  }

  putEditorInFocus(editor: CKEditorComponent) {
    // todo: fix to put editor in focus
    // editor.editorInstance?.editing.view.focus();
    // editor.editorInstance?.model.change(
    //   (writer: any) => writer.setSelection( writer.createPositionAt( editor.editorInstance?.model.document.getRoot(), 'end' ) )
    // );

    // setTimeout(() => {
    //   editor.editorInstance?.editing.view.focus();
    //   editor.editorInstance?.model.change(
    //     (writer: any) => writer.setSelection( writer.createPositionAt( editor.editorInstance?.model.document.getRoot(), 'end' ) )
    //   );
    // }, 0);
  }

  public convertMarkdownToHtml() {
    const marked = require('marked');
    marked.setOptions({});
    this.story.content = marked.parse(this.story.content);
  }
}
